import {UploadFile} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React from "react";

type FileControlType = {
    name: string;
    reset?: any;
}

const FileControl = (props: FileControlType) => {
    const { control, getValues } = useFormContext();

    return (
        <Controller
            control={control}
            name={props.name}
            rules={{ required: true }}
            render={({field, fieldState}) =>
                <UploadFile
                    onChange={(e: any) => field.onChange(e)}
                    accept={'.pdf'}
                    extensionDisplayValue={'PDF'}
                    reset={props.reset}
                    singleFileOnly={true}
                />
            }
        />
    )
}

export { FileControl }
